/**
 * @description Enum for the required params to verify a route.
 */
export enum RequiredParam {
  Token = 'token',
}
